import type {
  StepTransitionSettings,
  StepTransitionVariant,
} from "./form-types";

import {
  DEFAULT_STEP_TRANSITION_DELAY_BEFORE_EXIT_MS,
  DEFAULT_STEP_TRANSITION_DURATION_MS,
  DEFAULT_STEP_TRANSITION_VARIANT,
} from "@homeinstead/schemas";

/**
 * The outgoing step leaves faster than the incoming step arrives. A symmetric
 * exit reads as sluggish because the user is already waiting on their own click.
 */
const EXIT_DURATION_RATIO = 0.6;

// Same curve as AnimatedReveal's EASE_OUT (AnimatedReveal/animation-variants.ts),
// duplicated here as a plain CSS value since this transition runs on Tailwind's
// inline style, not Motion.
const STEP_TRANSITION_EASE_TAILWIND = "cubic-bezier(0.25,0.46,0.45,0.94)";

function getExitDurationMs(enterDurationMs: number): number {
  return Math.round(enterDurationMs * EXIT_DURATION_RATIO);
}

type StepTransitionConfig = {
  delayBeforeExitMs: number;
  enterDurationMs: number;
  exitDurationMs: number;
  variant: StepTransitionVariant;
};

function resolveStepTransitionConfig(
  settings: StepTransitionSettings | null | undefined,
): StepTransitionConfig {
  const enterDurationMs =
    settings?.duration ?? DEFAULT_STEP_TRANSITION_DURATION_MS;
  return {
    delayBeforeExitMs:
      settings?.delayBeforeExit ?? DEFAULT_STEP_TRANSITION_DELAY_BEFORE_EXIT_MS,
    enterDurationMs,
    exitDurationMs: getExitDurationMs(enterDurationMs),
    variant: settings?.variant ?? DEFAULT_STEP_TRANSITION_VARIANT,
  };
}

export {
  EXIT_DURATION_RATIO,
  getExitDurationMs,
  resolveStepTransitionConfig,
  STEP_TRANSITION_EASE_TAILWIND,
};
